import { Injectable } from '@angular/core';
import { mergeMap, of } from 'rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, switchMap, takeUntil } from 'rxjs/operators';
import * as AnalysisStridesActions from '../actions/analysis-strides.actions';
import { AnalysisStridesService } from '../services/analysis-strides.service';
import { SubscriptionService } from '../../common-store/services/subscription.service';
import {
  ErrorStore,
  ErrorStoreStatusEnum,
  StridesStoreItem,
} from '@sleipai/sleip-models';

@Injectable()
export class AnalysisStridesEffects {
  loadSharedAnalysisResultStrides$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AnalysisStridesActions.loadAnalysisStridesByIdAndPublicKey),
      switchMap(({ publicRecordingId, publicKey, version, recordingId }) => {
        return this.analysisStridesService
          .loadSharedAnalysisResultsStridesByIdAndKey(
            publicRecordingId,
            publicKey,
            version,
            recordingId
          )
          .pipe(
            takeUntil(this.subService.unsubscribe$),
            switchMap((data: StridesStoreItem) => {
              return [
                AnalysisStridesActions.loadAnalysisStridesSuccess({
                  data,
                }),
              ];
            })
          );
      }),
      catchError(({ message, code }) => {
        const firebaseErrorCode = code as string;
        const error: ErrorStore = {
          message: message,
          status:
            firebaseErrorCode?.replace('functions/', '') ??
            ErrorStoreStatusEnum.INTERNAL,
        };
        return of(
          AnalysisStridesActions.loadAnalysisStridesFailure({
            error,
          })
        );
      })
    );
  });

  loadAnalysisResultStrides$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AnalysisStridesActions.loadAnalysisStridesById),
      mergeMap(({ recordingId, isFlexion }) => {
        return this.analysisStridesService
          .loadAnalysisResultsStridesById(recordingId, !!isFlexion)
          .pipe(
            mergeMap((data: StridesStoreItem) => {
              return [
                AnalysisStridesActions.loadAnalysisStridesSuccess({
                  data,
                }),
              ];
            })
          );
      }),
      catchError((error) => {
        const errorStore: ErrorStore = {
          message: error?.message ?? error,
          status: ErrorStoreStatusEnum.INTERNAL,
        };
        return of(
          AnalysisStridesActions.loadAnalysisStridesFailure({
            error: errorStore,
          })
        );
      })
    );
  });

  constructor(
    private actions$: Actions,
    private subService: SubscriptionService,
    private analysisStridesService: AnalysisStridesService
  ) {}
}
